(function () {
  // El chequeo de localStorage y el ocultado inmediato de la barra (si el
  // usuario ya la había cerrado) se hacen en un script inline minúsculo en
  // sections/announcement-bar.liquid, para que se ejecute antes del primer
  // pintado y no haya flash. Aquí solo continuamos si la barra sigue visible.
  if (window.__nxAnnBarClosed) return;

  var KEY = 'ng_bar_v3';
  var bar = document.getElementById('announcement-bar');
  if (!bar) return;

  function syncH() {
    document.documentElement.style.setProperty('--announce-h', bar.offsetHeight + 'px');
  }
  syncH();
  window.addEventListener('resize', syncH);

  var btn = document.getElementById('announcementClose');
  if (btn) {
    btn.addEventListener('click', function () {
      var h = bar.offsetHeight;
      bar.style.height = h + 'px';
      bar.style.transition = 'height 0.3s ease, opacity 0.3s ease';
      requestAnimationFrame(function () {
        bar.style.height = '0';
        bar.style.opacity = '0';
        document.documentElement.style.setProperty('--announce-h', '0px');
      });
      setTimeout(function () {
        bar.style.display = 'none';
        localStorage.setItem(KEY, '1');
      }, 320);
    });
  }
})();
